import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { RefreshService } from './services/refresh.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-authentication-container',
  templateUrl: './authentication.container.component.html',
  styleUrls: ['./authentication.container.component.scss']
  // changeDetection: ChangeDetectionStrategy.OnPush
  // ARC-12597 if we set this to OnPush, it exposes a bug in the login container component,
  // where if the auth token is expired, the isBypass flag will be left at the default
  // value of true, and hide the login component completely. Not wanting to risk breaking
  // login workflows, we'll keep the default change detection strategy for now
})
export class AuthenticationContainerComponent implements OnInit, OnDestroy {
  constructor(
    private refreshService: RefreshService
  ){}

  public isBypass: boolean;
  public isLoggedIn = true;
  public refreshSubscription: Subscription;
  public isLoggedInSubscription: Subscription;

  ngOnInit(): void {
    this.isLoggedInSubscription = this.refreshService.isLoggedIn$.subscribe(
      isLoggedIn => this.isLoggedIn = isLoggedIn
    );

    this.refreshSubscription = this.refreshService.isBypass$.subscribe(
      (isBypass) => this.isBypass = isBypass
    );
  }
  ngOnDestroy(): void {
    this.refreshSubscription.unsubscribe();
    this.isLoggedInSubscription.unsubscribe();
  }
}
